/**
 * Cómo llega un error de la caja (contrato §2.2 de trd-docs
 * `evolution/proposals/OFFLINE-POS-RONDA-1.md`).
 *
 * El código viene en uno de dos lugares, y la caja decide por él:
 * - el `errorCode` de core, que el BFF reenvía sin rearmar
 *   (`{ statusCode, message, errorCode, … }`);
 * - el `code` del propio BFF (`{ statusCode, code, data: { message } }`):
 *   `business_suspended`, `not_permitted`, `stale_business_state`,
 *   `authz_unavailable`.
 *
 * Algunos 403 del BFF no traen ninguno de los dos.
 */

/** El status HTTP del error, o `undefined` si no hubo respuesta. */
export function estadoDelError(error: unknown): number | undefined {
  const status = (error as { response?: { status?: unknown } })?.response
    ?.status;
  return typeof status === "number" ? status : undefined;
}

/** El código del error, de core o del BFF. */
export function codigoDelError(error: unknown): string | undefined {
  const data = (error as { response?: { data?: unknown } })?.response?.data as
    | { errorCode?: unknown; code?: unknown }
    | undefined;
  for (const candidato of [data?.errorCode, data?.code]) {
    if (typeof candidato === "string" && candidato.trim() !== "") {
      return candidato;
    }
  }
  return undefined;
}
